export const teamNames1 = ["Annihilators",
"Avengers",
"Bad to The Bone",
"Panthers",
"Black Widows",
"Blitzkrieg",
"Braindead Zombies",
"Brewmaster Crew",
"Brute Force",
"Butchers",
"Chaos",
"Chargers",
"Chernobyl",
"Collision Course",
"Deathwish",
"Defenders",
"Demolition Crew",
"Desert Storm",
"Divide and Conquer",
"Dominators",
"Dropping Bombs",
"End Game",
"Enforcers",
"Fire Starters",
"Gargoyles",
"Gatling Guns",
"Ghost Riders",
"Grave Diggers",
"Gunners",
"Guns for Hire",
"Hammerheads",
"Hell’s Angels",
"Hellraisers",
"High-Voltage",
"Insurgents",
"Jawbreakers",
"Justice Bringers",
"Lethal",
"Mean Machine",
"Mercenaries",
"Mud Dogs",
"Mutiny",
"Nemesis",
"No Fear",
"No Rules",
"No Sympathy",
"One Shot Killers"
];

export const teamNames2 = ["Pulverizers",
"Rage",
"Raging Bulls",
"Rhinos",
"Savages",
"Shock and Awe",
"Skull Crushers",
"Slayers",
"Soldiers",
"Soul Takers",
"Speed Demons",
"Stone Crushers",
"Tech Warriors",
"Terminators",
"Terrorizers",
"The Arsenal",
"The Barbarians",
"The Blazers",
"The Yellow Jackets",
"The Demented",
"The Enemy",
"The Fighting Irish",
"The Firing Squad",
"The Frontline",
"The Hit List",
"The House Thrashers",
"The Intimidators",
"The Mean Ones",
"The Outlaws",
"The Pitbulls",
"The Punishers",
"The Reapers",
"The Rebellion",
"The Security",
"The Storm Bringers",
"The Tribe",
"The Unredeemable",
"Trigger Happy",
"Vandals",
"Veterans",
"Vigilantes",
"Viking Raiders",
"Warmongers",
"Your Worst Nightmare"];